'use strict';
const angular = require('angular');

export function recentVisitsService($localStorage) {
  'ngInject';

  let limit = 7;

  let typeMap = {
    "wo": "workItems",
    "ccr": "workItems",
    "sr": "workItems",

    "project": "projects",

    "community": "portfolio",
    "property": "portfolio",
    "contact": "portfolio",
    "vendor": "portfolio",
    "webaccess": "portfolio",
    "custom": "portfolio"
  };

  let addToSessionStore = (type, item) => {
    let id = item.id;
    let collection = typeMap[type];

    let idx = $localStorage.recent[collection].findIndex(storageItem => {return storageItem.id == item.id});

    if (idx == -1) {    // item not there yet, add it to the beginning
      $localStorage.recent[collection].unshift(item);
    } else { // item was already there, place it on the beginning
      $localStorage.recent[collection].splice(idx, 1);
      $localStorage.recent[collection].unshift(item);
    }

    if ($localStorage.recent[collection].length > limit) {
      $localStorage.recent[collection].splice(limit, 1);
    }
  };

  let typeUrlMap = {
    "wo": "/workorder/ticket/detail/",
    "sr": "/servicerequest/ticket/detail/",
    "ccr": "/violation/ticket/detail/",

    "community": "/community/",
    "property": "/property/",
    "contact": "/contact/",
    "vendor": "/vendor/",

    "webaccess": "/webaccess/",
    "custom": "/custom/"
  };

  if (!$localStorage.recent)
    $localStorage.recent = {};

  if (!$localStorage.recent.workItems)
    $localStorage.recent.workItems = [];

  if (!$localStorage.recent.projects)
    $localStorage.recent.projects = [];

  if (!$localStorage.recent.portfolio)
    $localStorage.recent.portfolio = [];

  return {

    workItems: $localStorage.recent.workItems,
    projects: $localStorage.recent.projects,
    portfolio: $localStorage.recent.portfolio,

    addWorkItem(id, type, name) {
      addToSessionStore(type, {
        id: id,
        name: name,
        path: typeUrlMap[type] + id
      })
    },

    addProject(id, name) {
      addToSessionStore("project", {
        id: id,
        name: name,
        path: "/project/" + id
      })
    },

    addPortfolio(id, type, name) {
      addToSessionStore(type, {
        id: id,
        name: name,
        path: typeUrlMap[type] + id
      })
    },

    addCustomPortfolio(id, type, customType, name) {
      addToSessionStore(type, {
        id: id,
        name: name,
        path: typeUrlMap[type] + customType + "/" + id
      })
    }

  };
}

export default angular.module('conduu.recentVisits', [])
  .factory('RecentVisits', recentVisitsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/recent-visits/recent-visits.service.js